export const formatRequestFormCode = (code?: string) => {
    if (!code) return ''
    return code.toUpperCase().replaceAll('O', '0').replaceAll('I', '1')
}
